import Project from "../Project";
import ProjectPosition from "../ProjectPosition";

import ServiceStep from "../../views/create-project/steps/ServiceStep";
import NameStep from "../../views/create-project/steps/NameStep";
import TimingStep from "../../views/create-project/steps/TimingStep";
import LocationStep from "../../views/create-project/steps/LocationStep";
import BudgetStep from "../../views/create-project/steps/BudgetStep";
import DescriptionStep from "../../views/create-project/steps/DescriptionStep";
import ReviewStep from "../../views/create-project/steps/ReviewStep";
import PositionStep from "../../views/create-project/steps/PositionStep";
import PostsOnJobBoardStep from "../../views/create-project/steps/PostsOnJobBoardStep";
import {generatePath} from "react-router-dom";
import PhaseDeliverablesStep from "../../views/create-project/steps/PhaseDeliverablesStep";
import TeamSkillsStep from "../../views/create-project/steps/TeamSkillsStep";
import TeamIndustriesStep from "../../views/create-project/steps/TeamIndustriesStep";
import TeamExperienceStep from "../../views/create-project/steps/TeamExperienceStep";
import ProjectVisibilityStep from "../../views/create-project/steps/ProjectVisibilityStep";

const HasProjectSteps = WrappedClass => {
    return class HasProjectWizard extends WrappedClass {

        static formSections(hasService = false) {

            if (hasService) {
                return {
                    // [this.ProjectSections.SectionType]: 10,
                    [this.ProjectSections.SectionProfile]: 30,
                    [this.ProjectSections.SectionServiceDeliverables]: 15,
                    // [this.ProjectSections.SectionServiceDisciplinesSkills]: 20,
                    [this.ProjectSections.SectionServiceSkills]: 15,
                    [this.ProjectSections.SectionServiceIndustries]: 15,
                    [this.ProjectSections.SectionServiceExperience]: 15,
                    // [this.ProjectSections.SectionServiceIndustries]: 20,
                    [this.ProjectSections.SectionReview]: 10,
                }
            }
            return {
                [this.ProjectSections.SectionType]: 10,
                [this.ProjectSections.SectionProfile]: 40,
                [this.ProjectSections.SectionPositions]: 40,
                [this.ProjectSections.SectionReview]: 10,
            }
        }

        static steps(projectOrService) {
            let projectId = 'new',
                project,
                projectType;

            if (TB.isDefined(projectOrService?.id)) {
                projectId = projectOrService.id;
                project = Project.make({...projectOrService});
                projectType = project.typeName();
            } else if (!isNaN(parseInt(projectOrService)) || projectOrService === 'new') {
                projectId = projectOrService;
            } else if (TB.isString(projectOrService)) {
                projectId = 'new';
            }
            // TODO Change with updated platform features for teams
            // if (!laravel.platform_features.clients.services) {
            //     projectType = TB.invert(laravel.project_types)[Project.ProjectType.BYO]
            // }
            let steps = [
                ServiceStep,
                NameStep
            ]

            if (projectId === 'new') {
                return TB.map(TB.filter(steps, step => step), (step, index) => {
                    step.index = index;
                    return step;
                });
            }

            steps = [
                ...steps,
                DescriptionStep,
                TimingStep,
                LocationStep,
                // projectType === Project.Type.Service && ManagedStep,
                // projectType === Project.Type.Service && BudgetStep,
                // projectType === Project.Type.Service && ContractTypeStep,
                // projectType === Project.Type.Service &&
                // project.questions?.length && !TB.filter(project.questions, ['was_answered', true]).length && ContinueOptionsStep,
                // projectType === Project.Type.BYO && !project.hasSetupAPosition() && TotalPositionsStep,
            ];

            if (projectType === Project.Type.Service) {
                steps.push(BudgetStep)
                steps.push(PhaseDeliverablesStep)
                steps.push(TeamSkillsStep)
                steps.push(TeamIndustriesStep)
                steps.push(TeamExperienceStep)
            }

            if (projectType === Project.Type.BYO) {
                if (project.positions?.length) {
                    let activePositions = project.positions;
                    TB.map(activePositions, (position, index) => {
                        class PositionSetupStep extends PositionStep {
                            /**
                             * The Question Id for the scope step
                             */
                            static PositionIndex = position.id;
                            static path = `/role/${position.id}`;
                            static slug = `role/${position.id}/*`;
                            static StepProgress() {
                                let percentCompleted = ((index + 1) / (activePositions.length + 1));

                                return 50 + TB.round((percentCompleted * 40))
                            }
                            static getPath(project) {
                                let projectId = TB.isObject(project) ? project.id : project;

                                return generatePath(`${TB.routes().clientProjectSetup}/role/${position.id}`, {
                                    projectId
                                })
                            }

                            static hasCompleted(project)
                            {
                                return project.validatePosition(this.PositionIndex);
                            }
                            static StepNeedsValidation(project) {

                                if (!project.validatePosition(this.PositionIndex)) {
                                    return this;
                                }

                                return false
                            };

                        }

                        steps.push(PositionSetupStep);
                    })
                }

                if (project.canAddPositions()) {
                    class PositionNewStep extends PositionStep {
                        /**
                         * No position ID if new position
                         */
                        static PositionIndex = 'new';
                        static path = `/role/new`;
                        static slug = `role/new/*`;
                        static StepProgress() {
                            return 50 + 40
                        }
                        static StepNeedsValidation = () => !project.positions?.length;
                    }

                    steps.push(PositionNewStep)
                }
                // if (project.isTimeMaterials()) {
                //     steps.push(PostsOnJobBoardStep)
                    steps.push(ProjectVisibilityStep)
                // }
            }

            steps.push(ReviewStep);

            return TB.map(TB.filter(steps, step => step), (step, index) => {
                step.index = index;
                return step;
            });
        }

        /*
        |--------------------------------------------------------------------------
        | Project Helper Methods
        |--------------------------------------------------------------------------
        */

        currentSteps()
        {
            return this.constructor.steps(this)
        }

        hasCompletedWizard = TB.memoize(this.checkCreateCompletion.bind(this));

        checkCreateCompletion() {

            for (let step of this.currentSteps()) {
                if (step.StepNeedsValidation(this)) return false;
            }

            return true
        }

        remainingSteps() {
            let steps = this.currentSteps(), lastStep = this.lastStepRemaining(steps);
            return steps.length - (steps.indexOf(lastStep))
        }

        lastStepRemaining(steps = this.currentSteps()) {

            for (let step of steps) {
                if (step.StepNeedsValidation(this)) {
                    // console.log('lastStepRemaining', step)
                    return step;
                }
            }
            return false
        }

        stepProgress() {
            let lastStepRemaining = this.lastStepRemaining();
            if (!lastStepRemaining) {
                return 100
            }

            return this.constructor.progressForStep(lastStepRemaining, this.isService())
        }

        currentStep() {

            let steps = this.currentSteps();
            let lastSavedStep = this.lastStepRemaining(steps);

            // console.log('currentStep', lastSavedStep);
            if (lastSavedStep) return lastSavedStep;

            let searchStep = NameStep;

            if (this.canEditScope()) {
                searchStep = ReviewStep;
            }


            return TB.find(steps, step => step.prototype instanceof searchStep);
        }


        static progressForStep(currentStep = ServiceStep, isService = true) {

            switch (currentStep) {
                case ServiceStep:
                // case ProjectPreviewStep:
                case NameStep:
                    if (!isService) return 10;
                    return 22;
                case DescriptionStep:
                    if (!isService) return 22;
                    return 24;
                case TimingStep:
                    if (!isService) return 25;
                    return 26;
                case LocationStep:
                    if (!isService) return 45;
                    return 28;
                case BudgetStep:
                    return 29;
                case PhaseDeliverablesStep:
                    return 40
                case TeamSkillsStep:
                    return 55;
                case TeamIndustriesStep:
                    return 70;
                case TeamExperienceStep:
                    return 85;
                case PostsOnJobBoardStep:
                    return 90;
                case ProjectVisibilityStep:
                    return 95;
                case ReviewStep:
                    return 100;
                default:

                    if (currentStep.prototype instanceof PositionStep) {

                        let progress = currentStep.StepProgress?.();

                        if (TB.isDefined(progress)){
                            return progress;
                        }
                    }

                    return 100
            }
        }

        transForStep(step,stepKey, replace = {}) {

            let transKey;
            switch (stepKey) {
                case 'service':
                case 'name':
                case 'description':
                case 'timing':
                case 'location':
                case 'budget':
                case 'review':
                    transKey = `${stepKey}_step`
                    break;
                case 'position':
                    transKey = 'positions_step'
                    break;
                // case 'post-on-wripple-job-board':
                //     transKey = 'posts_on_job_board_step'
                //     break;
                case 'project-visibility-settings':
                    transKey = 'posts_on_job_board_step'
                    break;
            }

            return TB.trans(
                `create_project.${transKey}.${stepKey}`, replace
            );
        }

        nameForStep(step) {

            switch (step) {
                case 'name':
                    return 'Name and Owners'
                case 'budget':
                    return 'Budget Range'
                case 'location':
                    return 'Location Preferences'
                case 'project-visibility-settings':
                // case 'post-on-wripple-job-board':
                case 'description':
                case 'timing':
                    return TB.startCase(step)
            }
        }

        typeLabelForStep() {
            return this.isBYO() ? 'Hire by Open Positions': this.template?.name
        }

        sectionForStep(step) {
            let subtitle;

            switch (step) {
                default:
                    subtitle = this.constructor.ProjectSections.SectionProfile;
                    break;
                case 'service':
                    subtitle = this.constructor.ProjectSections.SectionType;
                    break;
                case 'positions':
                    subtitle = this.constructor.ProjectSections.SectionPositions;
                    break;
                case 'review':
                    subtitle = this.constructor.ProjectSections.SectionReview;
                    break;
            }

            return subtitle;
        }

        wrapperClassForStep(step) {
            switch (step) {
                default:
                    return '';
                case 'review':
                    return 'review-step-container';
            }
        }

        formClassForStep(step) {
            switch (step) {
                default:
                    return 'wizard-form-step';
                case 'positions':
                    return 'wizard-position-step';
                case 'review':
                    return 'wizard-form-step wizard-review-step';
            }
        }

        pathForStep(step) {
            switch (step) {
                case 'service':
                    return  'select-service'
                case 'name':
                case 'budget':
                case 'description':
                case 'location':
                case 'review':
                case 'project-visibility-settings':
                // case 'post-on-wripple-job-board':
                    return TB.slugify(step)
                case 'timing':
                    return 'kickoff'
                case 'positions':
                    return 'role/:roleId'
            }
        }

        validationForStep(step, index) {
            switch (step) {
                case 'service':
                    return this.validateService();
                case 'name':
                    return this.validateName()
                case 'budget':
                    return this.validateBudget()
                case 'location':
                    return this.validateLocation()
                // case 'post-on-wripple-job-board':
                //     return this.validatePostsOnJobBoard()
                case 'project-visibility-settings':
                    return this.validatePostsOnJobBoard() && this.validateVisibilitySettings()
                case 'positions':
                    return this.validatePosition(index)
                case 'description':
                    return this.validateDescription()
                case 'timing':
                    return this.validateTiming()
                case 'review':
                    return this.validateReview()
            }
        }

        mappingForStep(params) {
            // switch (step) {
            //     case 'service':
            //         return this.validateService();
            //     case 'name':
            //         return this.validateName()
            //     case 'budget':
            //         return this.validateBudget()
            //     case 'location':
            //         return this.validateLocation()
            //     case 'post-on-wripple-job-board':
            //         return this.validatePostsOnJobBoard()
            //     case 'positions':
            //         return this.validatePosition(index)
            //     case 'description':
            //         return this.validateDescription()
            //     case 'timing':
            //         return this.validateTiming()
            //     case 'review':
            //         return this.validateReview()
            // }
            return params
        }

        fieldInvalidate(field) {
            return !TB.isDefined(this[field]) || TB.isNaN(this[field] ||
                (typeof this[field] === 'string' && !this[field].length))
        }

        validateService() {

            let fields = [
                'type'
            ];
            if (this.isService()) {
                fields.push('template')
            }
            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }

            if (this.isBYO()) {
                fields.push('client_project_group_id')
            }
            return TB.pick(this, fields);
        }

        validateName() {

            let fields = [
                'name'
            ]
            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }
            fields.push('client_project_group_id');

            let validated = TB.pick(this, fields);

            if(this.isBYO()) {
                validated.client_project_group_id = this.client_project_group_id || null;
                validated.assigned_users = TB.map(this.assigned_users || [], user => TB.pick(user, ['id', 'is_owner']));

            }
            return validated;
        }

        validateDescription() {

            let fields = [
                'description'
            ]

            return TB.pick(this, fields);
        }

        validatePostsOnJobBoard() {

            let fields = [
                'posts_on_talent_job_board'
            ]

            return TB.pick(this, fields);
        }

        async validateVisibilitySettings() {

            let fields = [
                'visibility_setting_location',
                'visibility_setting_hired',
                'visibility_setting_favorites',
                'visibility_setting_invited',
                'visibility_setting_all_talent',
                // 'visible_regions',
                'visible_talent_pools',
                'posts_on_talent_job_board'
            ]

            let settings = {...(TB.pick(this, fields))};

            settings.visible_talent_pools = settings.visible_talent_pools || [];
            if (parseInt(settings.visibility_setting_location) === TB.locationRegionalSetting()) {
                let availableRegions = TB.auth().user()?.client_organization?.regions || [];
                if (availableRegions?.length && !settings.visible_regions?.length) {
                    settings.visible_regions = [TB.first(availableRegions)];
                }
            }
            if (!settings.visibility_setting_location) {
                settings.visibility_setting_location = TB.locationGlobalSetting();
            }
            if (settings.visibility_setting_location !== TB.locationRegionalSetting()) {
                settings.visible_regions = [];
            }
            if(!settings.visibility_setting_hired) {
                settings.visibility_setting_hired = 0;
            }
            if(!settings.visibility_setting_favorites) {
                settings.visibility_setting_favorites = 0;
            }
            if(!settings.visibility_setting_invited) {
                settings.visibility_setting_invited = 0;
            }
            if (!settings?.visible_talent_pools?.length) {
                settings.visible_talent_pools = []
            }
            settings.visibility_setting_all_talent = false;
            return settings
        }

        validateDeliverables() {
            let fields = TB.pick(this, ['phases', 'skills', 'disciplines']);

            fields.phases = TB.map(fields.phases, phase => {
                let deliverables = TB.map(
                    phase.deliverables,
                    deliverable => {
                        return TB.pick(deliverable,
                            ['id', 'name', 'description', 'is_desired', 'client_comments']
                        )
                    }
                );

                return {
                    ...phase,
                    deliverables
                }
            });

            return fields;
        }

        validateSkills() {

            let fields = TB.pick(this, ['disciplines', 'skills']);

            // if (!fields.min_score) {
            //     return false
            // }
            return fields
        }

        validateTeamExperience() {

            let fields = TB.pick(this, [
                'wants_intermediate_experience',
                'wants_senior_experience',
                'wants_junior_experience',
                'expertise_notes'
            ]);

            if (!fields.wants_intermediate_experience && !fields.wants_senior_experience && !fields.wants_junior_experience) {
                return false
            }
            return fields
        }

        validateTeamIndustries() {

            let fields = TB.pick(this, ['industries']);

            return fields
        }

        validateTiming() {

            let fields = [
                'start_range',
            ]
            if (this.isHiringSourceTalentPoolReq() || this.isHiringSourceQuickHire()) {
                return true
            }
            if (!this.isBYO()) {
                if (TB.isDefined(this.weeks_to_finish)) {
                    fields.push('weeks_to_finish')
                }else if (TB.isDefined(this.delivery_date)){
                    fields.push('delivery_date')
                }else return false;
            }

            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }

            return TB.pick(this, fields);
        }

        validateLocation() {

            let fields = [
                'location',
            ]
            // if (this.isService()) {
            //     fields.push('allow_remote_team')
            //     if(this.requires_onsite_team) {
            //         fields.push('avg_onsite_days_per_week');
            //     }
            // }

            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }
            return TB.pick(this, fields);
        }

        validateManaged() {

            let fields = [
                'is_managed'
            ];
            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }
            return TB.pick(this, fields);
        }

        validateBudget() {

            let fields = [];

            let hasMax = TB.isNumber(this.max_budget);
            let hasMin = TB.isNumber(this.min_budget)

            if (hasMin) fields.push('min_budget');
            if(hasMin && this.min_budget < 500) {
                return false;
            }else if(hasMin && this.min_budget > 10000000) {
                return false
            }

            if (hasMax) fields.push('max_budget');
            if(hasMax && hasMin && this.max_budget < this.min_budget) {
                return false;
            }else if(hasMax && hasMax > 10000000) {
                return false
            }

            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }

            return TB.pick(this, fields);
        }

        validateContractType() {

            let fields = [
                'contract_type'
            ];
            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }
            return TB.pick(this, fields);
        }

        validateTotalPositions() {
            let fields = [
                'positions_count'
            ];
            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }
            return TB.pick(this, fields);
        }

        validateScope(question_id) {

            if (!TB.isDefined(question_id)) return false;

            let question = this.activeQuestionWithId(question_id);

            if (!question || !question.isAnswered()){
                return false;
            }

            return question;
        }

        validatePosition(positionId) {
            if (!TB.isDefined(positionId)) return false;
            let position = false;
            if (positionId === 'new') {
                position = TB.find(this.positions, pos => !TB.isDefined(pos.id));
            }else {
                position = TB.find(this.positions, ['id', parseInt(positionId)]);
            }

            if (!position){
                return false;
            }

            if (!TB.isFunction(position)){
                position = ProjectPosition.make({...position});
            }

            if (position.needsSetup()){
                return false;
            }

            return TB.pick(this, ['positions']);
        }

        validateReview() {
            let fields = [
                'setup_at'
            ];
            for (let field of fields) {
                if(this.fieldInvalidate(field)) {
                    return false;
                }
            }
            return TB.pick(this, fields);
        }
    }


}

export default HasProjectSteps